import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { SocialLogin } from "app/account/social-login";

/**
 * Handle Google Drive login before loading a component
 */
@Injectable({
   providedIn: "root",
})
export class GoogledriveAuthGuardService  {
   constructor(private socialLogin: SocialLogin) {}

   canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> {
      let accessToken = sessionStorage.getItem('access_token_google');
      if (accessToken && (accessToken != null)) {
         return true;
      }

      return this.socialLogin.withGoogle().pipe(
         map( (userGoogleDriveProfile) => {
            if (userGoogleDriveProfile?.accessToken === sessionStorage.getItem('access_token_google')) {
               // Success login Google
               return true;
            }
            return false;
         })
      );
   }
}
